import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-holder',
  templateUrl: './doc-holder.component.html',
  styleUrls: ['./doc-holder.component.scss']
})
export class DocHolderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
